import HubSpotAppLink from '../../common/components/HubSpotAppLink';
import { isIdle, isLoading, isRejected } from '../../common/types/FetchStatus';
import { getRecordPageHref } from './getRecordHref';
import { useObjectTypeSupportsRecord } from './useObjectTypeSupportsRecord';
import GenericLink from './GenericLink';
import { jsx as _jsx } from "react/jsx-runtime";
const RecordPageLink = ({
  children,
  external,
  handleClick,
  hideIfNotSupported,
  includeEschref,
  LinkComponent,
  LinkComponentProps,
  objectId,
  objectTypeId,
  onTrackClick
}) => {
  const objectTypeSupportsRecordState = useObjectTypeSupportsRecord(objectTypeId);
  if (isIdle(objectTypeSupportsRecordState) || isLoading(objectTypeSupportsRecordState) || isRejected(objectTypeSupportsRecordState)) {
    return /*#__PURE__*/_jsx("strong", {
      children: children
    });
  }
  if (!objectTypeSupportsRecordState.data) {
    return hideIfNotSupported ? null : /*#__PURE__*/_jsx("strong", {
      children: children
    });
  }
  if (external) {
    return /*#__PURE__*/_jsx(GenericLink, {
      dataSpeculationTarget: "crm-links-CRM_OBJECT_RECORD",
      external: true,
      href: getRecordPageHref(objectTypeId, objectId, {
        includeEschref
      }),
      LinkComponent: LinkComponent,
      LinkComponentProps: LinkComponentProps,
      onClick: handleClick,
      children: children
    });
  }
  return /*#__PURE__*/_jsx(HubSpotAppLink, {
    LinkComponent: LinkComponent,
    linkType: "CRM_OBJECT_RECORD",
    linkTypeProps: {
      includeEschref,
      objectTypeId,
      objectId
    },
    onTrackClick: onTrackClick,
    LinkComponentProps: LinkComponentProps,
    children: children
  });
};
export default RecordPageLink;